import { FieldType } from "@contentful/app-sdk";
import { htmlToDocument } from "../lib";

export const handleFieldTypesAfterTranslation = (
    value: string[],
    fieldType: FieldType
): string | string[] => {
    if (!value || value.length === 0) {
        if (fieldType === "Array") {
            return [];
        }
        return "";
    }

    if (fieldType === "RichText") {
        return htmlToDocument(value[0]);
    }

    if (fieldType === "Array") {
        return value;
    }

    return value[0];
};
